import { ToastContext } from "@/contexts/Toast/ToastContext";
import { use } from "react";

export default function useToast() {
  const toastContext = use(ToastContext);

  if (!toastContext) {
    throw new Error("This Hook must be used under ToastProvider!");
  }

  return toastContext;
}
